import styled from '@emotion/styled';

export const ColorsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 1px !important;
`;

export const StyledColorItem = styled.div<{ active: boolean; image?: string | null; color?: string }>`
  flex-shrink: 0;
  width: 27px;
  height: 30px;
  cursor: pointer;
  border: ${({ active }) => (active ? `2px solid #000` : '1px solid #A9A9A9')};
  border-radius: 4px;
  background: ${({ image, color }) => color ?? `url(${image}) center center no-repeat`};
  background-size: 120%;
`;
